import { getAppInsights } from '../../services/applicationInsights'
import { environment } from '../../config/environment'

const { appInsightsKey : VITE_APPINSIGHTS_KEY, mode } = environment

const useAppInsights = () => {
    if (mode !== 'test' && mode !== 'local') {
        return getAppInsights(VITE_APPINSIGHTS_KEY)
    }
    return null
}
export default useAppInsights
